module.exports = __webpack_public_path__ + "static/assets/6ce7364d2843d9227b32c62ed7d3520b.svg";